import React, { useContext, useMemo } from "react";
import { RightsContext } from "providers/RightsContext";
import { hasAuthorization } from "utils/functions";
import * as rightsCodes from "constants/rightsCodes";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { IconButton } from "@totalsoft/rocket-ui";
import AddIcon from "@mui/icons-material/Add";
import useLocator from "hooks/useLocator";

const HeaderLinks = ({ onAdd }) => {
  const { t } = useTranslation();
  const { isBank, isSelfPartner } = useLocator();
  const rights = useContext(RightsContext);
  const hasWritePermission = hasAuthorization(
    isBank ? rightsCodes.MASTER_PARTNER_BANKS_WRITE : rightsCodes.MASTER_PARTNER_WRITE,
    rights
  );

  const addTooltip = useMemo(() => {
    if (isBank) return t("Tooltips.AddBank");
    return t("Tooltips.Add");
  }, [isBank, t]);

  return !hasWritePermission || isSelfPartner ? null : (
    <IconButton id="partnerList_addBtn" onClick={onAdd} color="primary" variant="text" tooltip={addTooltip}>
      <AddIcon />
    </IconButton>
  );
};

HeaderLinks.propTypes = {
  onAdd: PropTypes.func.isRequired
};

export default HeaderLinks;
